import { createChart } from 'lightweight-charts';
import { observeChartSize } from './chartResize';

const MIN_CHART_PX = 8;

/**
 * Create a lightweight-charts instance once the container has non-zero size
 * (flex layouts often report 0×0 until siblings such as the roll-yield panel mount).
 */
export function mountListingChartWhenSized(container, createOptions, onChart) {
  if (!container) {
    return () => {};
  }

  let disposed = false;
  let chart = null;

  const syncSize = (width, height) => {
    if (disposed || width < MIN_CHART_PX || height < MIN_CHART_PX) return;

    if (!chart) {
      chart = createChart(container, {
        ...createOptions,
        width,
        height,
      });
      onChart(chart);
      return;
    }

    chart.applyOptions({ width, height });
  };

  const disconnectResize = observeChartSize(container, syncSize);

  requestAnimationFrame(() => {
    syncSize(container.clientWidth, container.clientHeight);
  });

  return () => {
    disposed = true;
    disconnectResize();
    if (chart) {
      chart.remove();
      chart = null;
    }
  };
}
